import React, { useState, useEffect } from 'react';
import { Target, Plus, ChevronRight, Check, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../../api/client';

const PathwaysBadgeCard = () => {
  const navigate = useNavigate();
  const [pathways, setPathways] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.request('/api/pathways/mine')
      .then(data => setPathways(data.owned?.filter(p => p.status === 'active').slice(0, 2) || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="card" data-testid="pathways-badge-card">
        <div className="card-header"><h2 className="card-title">My Badge Pathways</h2></div>
        <div className="flex justify-center py-6"><Loader2 size={20} className="animate-spin text-gray-400" /></div>
      </div>
    );
  }

  return (
    <div className="card" data-testid="pathways-badge-card">
      <div className="card-header">
        <h2 className="card-title">My Badge Pathways</h2>
        <button onClick={() => navigate('/pathways')} className="card-action flex items-center gap-1">
          View All <ChevronRight size={12} />
        </button>
      </div>

      {pathways.length === 0 ? (
        <div className="text-center py-6">
          <Target size={32} className="mx-auto text-gray-300 mb-2" />
          <p className="text-sm text-gray-500 mb-1">Design your own mini-journey</p>
          <p className="text-xs text-gray-400 mb-3">Complete small challenges and unlock a custom badge</p>
          <button
            onClick={() => navigate('/focus')}
            className="px-4 py-2 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 flex items-center gap-1 mx-auto"
            data-testid="create-pathway-btn"
          >
            <Plus size={14} /> Choose What to Work On
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          {pathways.map(p => {
            const done = p.progress?.completed || 0;
            const total = p.progress?.total || 1;
            const pct = Math.round((done / total) * 100);
            return (
              <div
                key={p.pathway_id}
                className="p-3 bg-gray-50 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors"
                onClick={() => navigate(`/pathways/${p.pathway_id}`)}
                data-testid={`pathway-${p.pathway_id}`}
              >
                <div className="flex items-center justify-between mb-1.5">
                  <span className="font-medium text-gray-900 text-sm">{p.title}</span>
                  <span className="text-xs text-gray-500">{done}/{total}</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-purple-500 h-2 rounded-full transition-all" style={{ width: `${pct}%` }} />
                </div>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-[10px] px-1.5 py-0.5 bg-purple-100 text-purple-600 rounded-full capitalize">{p.skill_area}</span>
                  <span className="text-[10px] px-1.5 py-0.5 bg-gray-100 text-gray-500 rounded-full capitalize">{p.context}</span>
                </div>
              </div>
            );
          })}
          <button
            onClick={() => navigate('/pathways/create')}
            className="w-full py-2 text-sm text-purple-600 font-medium hover:bg-purple-50 rounded-lg flex items-center justify-center gap-1"
          >
            <Plus size={14} /> Create New Pathway
          </button>
        </div>
      )}
    </div>
  );
};

export default PathwaysBadgeCard;
